import { cn, InputOtp, InputOtpProps } from '@heroui/react'
import { motion } from 'framer-motion'

export interface OtpProps extends Omit<InputOtpProps, 'classNames' | 'onChange'> {
  label?: string
  classNameContainer?: string
  classNames?: {
    base?: string
    input?: string[]
    inputWrapper?: string[]
    segmentWrapper?: string
  }
  name?: string
  isRequired?: boolean
  value?: string
  onChange?: (value: string) => void
  onBlur?: () => void
  errorMessage?: string
}

const Otp = ({
  classNameContainer,
  classNames,
  name,
  isRequired = false,
  value,
  onChange,
  onBlur,
  errorMessage,
  ...props
}: OtpProps) => {
  return (
    <motion.div className={cn(classNameContainer)}>
      <InputOtp
        errorMessage={errorMessage}
        isInvalid={Boolean(errorMessage)}
        isRequired={isRequired}
        name={name}
        value={value || ''}
        variant="bordered"
        classNames={{
          segment: ['!text-gray-900', 'dark:!text-white'],
          ...classNames,
        }}
        onBlur={onBlur}
        onValueChange={onChange}
        {...props}
      />
    </motion.div>
  )
}

export default Otp
